export default __webpack_public_path__ + "static/media/inspiration2.909e8b15.jpg";